import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

interface UnlinkConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  contactName?: string;
}

const UnlinkConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  contactName,
}: UnlinkConfirmationDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs">
    <DialogTitle>Unlink Contact</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to unlink <strong>{contactName}</strong>? This
        will not delete the contact.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ p: 2 }}>
      <Button onClick={onClose} variant="outlined">
        Cancel
      </Button>
      <Button onClick={onConfirm} variant="contained" color="error">
        Unlink
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnlinkConfirmationDialog;
